import { useDesktopAgent } from "../../agent/useDesktopAgent";
import { usePatientAuthFlags } from "../../Hooks/usePatientAuthFlags";
import { useCrePermission } from "../../Hooks/useCrePermission";
import { CRE_PERMISSION } from "../../cre/crePermissions";
import { useI18nLanguage } from "../../i18n/hooks/useI18nLanguage";
import { getCompanionSettingsButtonClass } from "../navbar/navbarIconButtonClasses";
import CompanionAgentSettingsPopover from "./CompanionAgentSettingsPopover";

/**
 * Companion settings gear for the Patient Details header (CRE only).
 * WINDOWS_INJECTION gates opening/saving settings (visible but locked on deny).
 */
export default function CompanionAgentHeaderSettings() {
  const { isCreAuth } = usePatientAuthFlags();
  const { requirePermission } = useCrePermission();
  const { connected, sendCommand } = useDesktopAgent({
    enabled: isCreAuth,
  });
  const { isRTL } = useI18nLanguage();

  if (!isCreAuth) return null;

  return (
    <CompanionAgentSettingsPopover
      connected={connected}
      sendCommand={sendCommand}
      isRTL={isRTL}
      buttonClassName={getCompanionSettingsButtonClass(connected)}
      onBeforeOpen={() => requirePermission(CRE_PERMISSION.WINDOWS_INJECTION)}
    />
  );
}
